// 校验是否邮箱
export const isEmailValid = val => {
  let reg = /^[A-Za-z0-9._%-]+@([A-Za-z0-9-]+\.)+[A-Za-z]{2,4}$/
  let ret = reg.test(val)
  return ret
}

//  校验网址是否正确
export const isHttpAddrValid = addr => {
  /* eslint-disable-next-line  */
  let reg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/
  let ret = reg.test(addr)
  return ret
}

//  验证是否是整数
export const isValidInteger = val => {
  var r = /^\+?[1-9][0-9]*$/ //  正整数
  let flag = r.test(val)
  return flag
}

// 验证手机号 10-12位之间
export const isPhoneValid = val => {
  const r = /^[1][3,4,5,7,8][0-9]{8,9}$/
  return r.test(val)
}

// 密码格式
export const isPassword = pwd => {
  var r = /^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z0-9~!@&%#$^&()-_.*-+]{8,16}$/
  return r.test(pwd)
}



// WEBPACK FOOTER //
// ./src/utils/validator.js